import React from 'react';

interface EditButtonProps {
  label: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export const EditButtonComponent: React.FC<EditButtonProps> = ({ label, onClick }) => (
  <button type='button' onClick={onClick} className='bg-main-blue rounded-full px-2 text-sm text-white shadow-lg sm:px-4 sm:text-base'>
    {label}
  </button>
);

export default EditButtonComponent;
